import { GatsbyImage, IGatsbyImageData, getImage } from 'gatsby-plugin-image';
import React from 'react';
import './ProductSWBanner.scss';

import R4Image from '../../assets/Hardware/r4.png';
import IdeImage from '../../assets/Software/ide2.png';
import PLCImage from '../../assets/Software/PLCide.png';
import classnames from 'classnames';

interface ProductSWBannerProps {
  title: string;
  description: string;
  label?: string;
  image?: any | IGatsbyImageData | string;
  svg?: boolean;
  bottom?: boolean;
  reverse?: boolean;
  cta?: {
    url: string;
    label: string;
    icon?: React.ReactElement;
    external?: boolean;
    primary?: boolean;
  }[];
}

const getStaticImage = (img) => {
  switch (img) {
    case 'board':
      return <img src={R4Image} alt="Welcome" className="grid-card__image--item boards" />;
    //return <StaticImage src={'../../assets/Hardware/r4.png'} alt="Board" className="banner__image-container--item" />;
    case 'ide':
      return <img src={IdeImage} alt="Welcome" className="grid-card__image--item boards" />;
    //return <StaticImage src={'../../assets/Software/ide2.png'} alt="Ide" className="banner__image-container--item" />;
    case 'PLCide':
      return <img src={PLCImage} alt="Welcome" className="grid-card__image--item boards" />;
    //return <StaticImage src={'../../assets/Software/PLCide.png'} alt="PLC Ide" className="banner__image-container--item" />;
    default:
      break;
  }
};

export default function ProductSWBanner({ title, description, image, cta, label, bottom, reverse }: ProductSWBannerProps): React.ReactElement {
  return (
    <section className={classnames('product-sw-banner', { banner__reverse: reverse })}>
      <div className="product-sw-banner__text-container">
        {label && <div className="product-sw-banner__label">{label}</div>}
        <h3>{title}</h3>
        <p>{description}</p>
        <div className="product-sw-banner__buttons">
          {cta &&
            cta.map((item) => (
              <a
                href={item.url}
                className={classnames('product-sw-banner__cta', { 'product-sw-banner__cta--primary': item.primary })}
                key={item.label}
                target={item.external ? '_blank' : null}
                rel="noreferrer"
              >
                {item.label} {item.icon ? item.icon : null}
              </a>
            ))}
        </div>
      </div>
      <div className="product-sw-banner__image-container">
        {image && image.extension === 'svg' && (
          // svg support
          <img src={image.publicURL} alt={'Featured'} className={classnames({ 'product-sw-banner__image-container--bottom': bottom })} />
        )}
        {typeof image === 'string' ? (
          <img src={image} alt={title} />
        ) : (
          <GatsbyImage alt={title} objectFit="cover" imgStyle={{ objectFit: 'cover' }} image={getImage(image)} />
        )}
        {image && getStaticImage(image)}
      </div>
    </section>
  );
}
